// Génère un post Facebook prêt-à-coller (modèle instantané, sans IA) pour un article de blog.
// Format : titre + accroche + hashtags locaux. Le lien est ajouté séparément par le composant de partage.

function toHashtag(str) {
  if (!str) return "";
  const cleaned = str
    .normalize("NFD").replace(/[\u0300-\u036f]/g, "") // retire les accents
    .replace(/&/g, " et ")
    .replace(/[^a-zA-Z0-9\s]/g, " ")
    .trim()
    .split(/\s+/)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join("");
  return cleaned ? `#${cleaned}` : "";
}

export function buildFbHashtags({ city, category } = {}) {
  const tags = [toHashtag(city), toHashtag(category), "#PROXIreduc28", "#EureEtLoir"];
  return [...new Set(tags.filter(Boolean))].join(" ");
}

// Texte du post SANS le lien (le lien est concaténé ensuite par FbGroupShare/ShareButton).
export function buildFbPost({ title, excerpt, city, category } = {}) {
  const parts = [];
  if (title) parts.push(title);
  if (excerpt) parts.push(excerpt);
  const tags = buildFbHashtags({ city, category });
  if (tags) parts.push(tags);
  return parts.join("\n\n");
}
